<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="position-relative grid-content">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="openAddPopup()" (click)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add Feedback Template</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('overAll',0)" (click)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>

        </div>
      </th>
      <th id="grid-header-container" *ngFor="let feedbackTemplateData of columnList; let ix = index;" [ngStyle]="{
                  'min-width': feedbackTemplateData.width,
                  'max-width': feedbackTemplateData.width,
                  'overflow': 'hidden',
                  'text-overflow': 'ellipsis',
                  'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()"
 >
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{ feedbackTemplateData.column }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div (click)="sortColumn(columnList[ix],feedbackTemplateData)" (keydown.enter)="sortColumn(columnList[ix],feedbackTemplateData)">
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
          </div>
        </div>
      </th>
      <th  class="sticky-col first-col"></th>
      <tr>
        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnList; let ix = index "
          [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
          class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()"
 >
          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(oneQmsUsersDataForTable1Data.key, $event)" /> </div>
        </td>
      </tr>
      <tr *ngFor="let list of pagedItems let idx = index;" [class.highlightRow]="list.childCheckBoxs == true">
        <td style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
            </div>
          </div>
        </td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><a href="" (click)="goToDetailPage(list,$event)">{{list.templateName}}</a></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{list.templateDescription}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{list.scoreFormula}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'">
          <div class="gridCheckBoxes">
            <img alt="access" *ngIf="list.isActive == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20" height="20">
            <img alt="noaccess" *ngIf="list.isActive != 'Y'" src="../../../assets/img/noAcessSymbol.svg" width="20" height="20">
          </div>
        </td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.createdOn | date:uiDateTimeFormat | uppercase}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.createdByUser}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{list.updatedOn | date:uiDateTimeFormat | uppercase}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{list.updatedByUser}}</span></td>
        <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{list.updateReason}}</span></td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Feedback Template" style="margin-left: 5px;"
              (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
            <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
              src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)" (keydown.enter)="openAuditTrail('individual',list)" />
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #addOrEditFeedbackTemplatePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-6">
          <!-- Template Name -->
          <div><label for="email ">Template Name</label><span class="mandatory-symbol">*</span></div>
          <input id="templateName" class="input-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateData.templateName">
          <span id="templateName-required-msg">Please enter an template name</span>
        </div>
        <div class="col-md-4">
          <div><label for="email ">Score Formula</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="feedbackTemplateData.scoreFormula">
        </div>


        <div class="col-md-2">
          <div><label for="isMand">Is Active?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="feedbackTemplateData.isActive1">
            <span class="active-inActive-container" *ngIf="feedbackTemplateData.isActive1==true"
              [ngStyle]="feedbackTemplateData.isActive1 == true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="feedbackTemplateData.isActive1==false"
              [ngStyle]="feedbackTemplateData.isActive1 == false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- Template Description -->
          <div><label for="email">Template Description</label></div>
          <textarea class="textarea-filed-continers" style="height: 150px;" type="text"
            [(ngModel)]="feedbackTemplateData.templateDescription"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(feedbackTemplateData)" (keydown.enter)="addAndEditFunction(feedbackTemplateData)" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(feedbackTemplateData)" (keydown.enter)="addAndEditFunction(feedbackTemplateData)"*ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="feedbackTemplateData.deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="deleteFunction()"(click)="deleteFunction()">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>